import moment from 'moment-timezone';
import { preload } from './preload-handler';
/**
 * The preload store module is used to dispatch certain actions that preload
 * data required by the app.
 *
 * To add a new preload action, export it, as shown below, and it will
 * be automatically added in this store module.
 *
 * @module store/preload
 */

/**
 * Dispatch your preload actions within the preloadData action. Use `await`
 * to ensure that your actions are executed in the order you need.
 *
 * @param dispatch
 * @returns {Promise<void>}
 */
export const preloadData = async ({ dispatch, commit }) => {
  commit('setPreloadingFlag', true);
  commit('setMenuItemsList', { items: null, remember: true }, { root: true });

  /*
  Wait for the following to preload.
  If more APIs added here update totalCount in the getter: preloadPercentage
  */

  //set the default date format for moment
  moment.defaultFormat = 'DD/MM/YYYY HH:mm:ss';

  await preload(dispatch('user-login/userDetails', null, { root: true }), 'User Details', commit);

  await Promise.all([
    dispatch('getLastUpdatedTimeStamps', null, { root: true }).then(() =>
      preload(dispatch('syncLanguages', true, { root: true }), 'Languages', commit)
    ),
    preload(dispatch('usersDelegatedBy'), 'Users Delegated By', commit),
    preload(dispatch('admin/system-variable/getFront', null, { root: true }), 'System Variables', commit)
  ]);
  dispatch('admin/application/getCategoryList', null, { root: true });
  dispatch('admin/application/getApplicationList', null, { root: true });
  dispatch('admin/application/fetchSolutionCategoriesList', null, { root: true });
  dispatch('user-login/fetchUserSpecificPlatformNotifications', null, { root: true });
  dispatch('user-login/fetchUserSpecificQuicklinks', null, { root: true });
  dispatch('header/getActiveDelegateCount', null, { root: true });
  commit('setPreloadingFlag', false);
};

export { usersDelegatedBy } from './handlers/users-delegated-by';
